"use strict";
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.IndividualStatus = void 0;
/**
 * An enumeration.
 */
var IndividualStatus;
(function (IndividualStatus) {
    IndividualStatus[IndividualStatus["NOT_CREATED"] = 0] = "NOT_CREATED";
    IndividualStatus[IndividualStatus["WAITING_EXT_VALIDATION"] = 1] = "WAITING_EXT_VALIDATION";
    IndividualStatus[IndividualStatus["RESUBMIT_REQUIRED"] = 2] = "RESUBMIT_REQUIRED";
    IndividualStatus[IndividualStatus["REUPLOAD_REQUIRED"] = 3] = "REUPLOAD_REQUIRED";
    IndividualStatus[IndividualStatus["PHONE_NUMBER_IN_USE"] = 4] = "PHONE_NUMBER_IN_USE";
    IndividualStatus[IndividualStatus["READY_FOR_CONSENT"] = 5] = "READY_FOR_CONSENT";
    IndividualStatus[IndividualStatus["CS_VERIFICATION"] = 10] = "CS_VERIFICATION";
    IndividualStatus[IndividualStatus["SENT_BACK_TO_CH"] = 11] = "SENT_BACK_TO_CH";
    IndividualStatus[IndividualStatus["MERGED"] = 14] = "MERGED";
    IndividualStatus[IndividualStatus["APPROVED"] = 20] = "APPROVED";
})(IndividualStatus = exports.IndividualStatus || (exports.IndividualStatus = {}));
